<template>
  <el-container>
    <div id="playHeader">
      <div id="logoimage">
        <img src="../static/image/smartcheck_logo.png" class="offLineRemove" 
        id="SmartCheckLogo" style="display: block; height: 42px; width: 116px; margin-top: 4px;">
        <span style="color:rgb(217 210 207);font-size: small;">动画方案仅供参考</span>
      </div>
      <div id="headBtnBox"> 
        <div id="viewBox"> 
          <!-- <div id="attachButton" @click="menuClick('attach')" class="viewBtn ctrlShowHide ctrlShowHideImg" data-menu="attach" data-show="attach">
            <div style="background-position-y:-345px"></div>
            <label data-lang="attach">附件</label>
          </div>           -->
          <div id="contrastButton" @click="menuClick('contrast')" class="viewBtn ctrlShowHide ctrlShowHideImg" data-menu="contrast" data-show="contrast">
            <div style="background-position-y:-443px"></div>
            <label data-lang="contrast">对比</label>
          </div>
          <div id="occlusionButton" class="viewBtn ctrlShowHideImg ctrlShowHide" @click="menuClick('occlusion')" data-menu="occlusion" data-show="occlusion" >
            <div style="background-position-y:-245px"></div>
            <label data-lang="occlusion" >咬合</label>
          </div>
          <!-- <div @click="menuClick('dbJaw')" style="display: none;" class="viewBtn ctrlShowHideImg viewCtroller" data-menu="dbJaw" data-board="2" id="dbJawButton">
            <div style="background-position-y:-840px"></div>
            <label data-lang="dbJaw">颌面观</label>
          </div> -->
        </div>  
      </div>
      <div id="shareDiv" class="offLineRemove">
        <div class="greenBtnHollow headBtn" id="shareLink" @click="shareClick()" data-lang="shareLink">分享</div>
      </div>      
    </div>
    <div id="playBody">
      <div id="pationBox">
          <div id="designSheetDiv">
            <label style="font-size: 20px; margin-right: 10px;">{{ nickname }}<span style="color:#f9763d;font-size: medium;">({{ age }})</span></label>
            <el-badge :hidden ="designSheetUrl != null ? false : true" is-dot class="item">
              <el-link type="primary" @click="toCard(designSheetUrl)" :underline="false">
                矫治方案<i class="el-icon-document"></i>
              </el-link>
            </el-badge>              
          </div>
         
      </div> 
      <div id="angleBox">
        <ul id="cameraDir">
          <li class="Vupper glChangeView" @click="upperClick" id="upperLi" data-type="upper">
            <div></div>
            <label data-lang="upper">上颌</label>
          </li>
          <li class="Vright glChangeView" @click="spinClick('modelRight')" id="rightLi">
            <div></div>
            <label data-lang="modelRight">左侧</label>
          </li>
          <li class="Vfront glChangeView angleTrue" @click="spinClick('modelFont')" id="frontLi">
            <div></div>
            <label data-lang="modelFont">正面</label>
          </li>
          <li class="Vback glChangeView" @click="spinClick('modelBack')" id="backLi">
            <div></div>
            <label data-lang="modelBack">后视</label></li>
          <li class="Vleft glChangeView" @click="spinClick('modelLeft')" id="leftLi">
            <div></div>
            <label data-lang="modelLeft">右侧</label>
          </li>
          <li class="Vlower glChangeView" @click="lowerClick" id="lowerLi" data-type="lower">
            <div></div>
            <label data-lang="lower">下颌</label>
          </li>
        </ul>
      </div>  
      <div id="plyRender" class="backImg0-remove" style="height: 479px;">
        <!-- 动态加载 -->
        <div id="loadDiv">
          <label id='loadingValue' style="padding-left:110px;color: #18429a;">0%</label>
        </div>
        <div style="height: 100%;" ref="webgl">                      
        </div>        
      </div>  
      
    </div>
    <div id="playFooter">
      <!-- <div id="plyStepPosition">         -->
        <div class="plyMenu">
          <div id="plySwitch">
            <div id="plyFirstBox">
              <div id="plyFirst" class="plyFirst playBtn" @click="lastStepClick"></div>
            </div>
            <div id="plyPlayBox">
              <div id="plyPlay" class="plyPlay playBtn slt" @click="startPlayClick"></div>
            </div>
            <div id="plyLastBox">
              <div id="plyLast" class="plyLast playBtn" @click="nextStepClick"></div>
            </div>   
            <div id="stepNumber">              
                <el-badge :value= stepNum  class="item"> 
                </el-badge>
            </div>            
          </div>
        </div>
        <div class="progressMenu">
          <div style="height: 32px" id="plySwitch">            
            <div id="progressDiv" style="left: 17px;width: 270px;">
              <el-slider :min=1 :max=maxStepNum v-model="stepNum" @input="handleChange"></el-slider>
            </div>
          </div>          
        </div>
      <!-- </div> -->
      <div id="bottomBanner" style="" class="offLineRemove">
        <img src="../static/image/banner.png" width="220" />
      </div>
    </div>
  </el-container>
</template>
<script>
import { renderer } from "./business/index.js";
import { attachmentsMenu } from "./business/index.js";
import { occlusMenu } from "./business/index.js";
import { dbJawMenu } from "./business/index.js";
import { contrastMenu } from "./business/index.js";
import { upToothClick } from "./business/index.js";
import { lowerToothClick } from "./business/index.js";
import { spinToothClick } from "./business/index.js";
import { initLoadModel } from './business/modelGltf.js';
import { stepClick } from './business/modelGltf.js';

export default { 
  mounted:function(){
    //获取请求参数并判断请求地址是否正确
    let requestUrl = this.$route.fullPath;
    let queryName = requestUrl.split('?')[0].substring(1,requestUrl.split('?')[0].length);    
    if(queryName != "search" || typeof(this.$route.query.sn) == "undefined" || this.$route.query.sn.length != 16){
      this.$message({
        message: '请求地址有误',
          type: "warning",
          duration: 1000
        });
        return;      
    }else{
      //1.请求数据，获取订单号相关的人员
       this.getPatientData(this.$route.query.sn);        
       this.$refs.webgl.appendChild(renderer.domElement); 
    }
  },
  methods: {
    getPatientData(sn){
      var requestUrl = "https://yym.ruikeyiliao.cn";//线上后台请求地址
      //var requestUrl = "http://localhost:8003"; //本地后台请求地址
      this.$http({
              url: requestUrl + `/yymApi/business/patient/getInfoByOrderSn/`+ sn,
              method: 'get'
            }).then(({data}) => {
              if (data && data.code === 0) {
                console.info("获取人员基本信息:", data.patient);
                this.nickname = data.patient.nickname;
                this.age = data.patient.age;
                this.maxStepNum = data.patient.maxStep;
                this.upMaxStepNum = data.patient.upMaxStep;
                this.downMaxStepNum = data.patient.downMaxStep;
                this.designSheetUrl = data.patient.designSheetUrl;
                //2.加载模型
                initLoadModel(sn,this.upMaxStepNum,this.downMaxStepNum);    
            }
        });
    },
    formatTooltip(val) {
        return val / 100;
    },
    //菜单操作方法
    menuClick(menuType){   
      switch(menuType) {
        case 'attach':
            attachmentsMenu();
            break;
        case 'contrast':
            contrastMenu();
            break;
        case 'occlusion':
            occlusMenu();
            break;    
        default:
            dbJawMenu();
      } 
    },
    //页面体中的方法
    upperClick(){
      upToothClick();
    },
    lowerClick(){
      lowerToothClick();
    },
    spinClick(direction){
      spinToothClick(direction);
    },
    //页面脚中的方法
    lastStepClick(){     
      this.stepNum = this.stepNum <= 1 ? 1 : this.stepNum -1; 
      stepClick(this.stepNum);
    },   
    startPlayClick(){
      let _this = this;
      let odiv= document.getElementById("plyPlay");
      if(!_this.play){
          this.play = true;
          odiv.classList.remove("slt");
          _this.playTimer = setInterval(function () { 
          _this.stepNum = _this.stepNum >= _this.maxStepNum ? _this.maxStepNum : _this.stepNum + 1;
          let stepValue = _this.stepNum < 10 ? '0' + _this.stepNum : _this.stepNum;
          if(stepValue >= _this.maxStepNum){ 
            this.play = false;           
            clearInterval(_this.playTimer);
            odiv.classList.add("slt");
          }else{
            stepClick(_this.stepNum);
          }
        },500);
      }else{
        clearInterval(_this.playTimer);
        this.play = false;
        odiv.classList.add("slt");
        
      }
    },
     nextStepClick(){    
      this.stepNum = this.stepNum >= this.maxStepNum ? this.maxStepNum : this.stepNum + 1;
      stepClick(this.stepNum);
    },
    handleChange(value){
     stepClick(value);
    },
    shareClick(){
      let url = window.location;
      //复制路径
      let inputNode = document.createElement('input')  // 创建input
      inputNode.value = url // 赋值给 input 值
      document.body.appendChild(inputNode) // 插入进去
      inputNode.select() // 选择对象
      document.execCommand('Copy') // 原生调用执行浏览器复制命令
      inputNode.className = 'oInput'
      inputNode.style.display = 'none' // 隐藏
      this.$message({
          message: '链接已复制',
          type: 'success'
        });
    },
    toCard(href){
      if(href === ''|| href === null || href === undefined){
        return false;
      }else{
        window.open(href, '_blank');
      }      
    }
  },
  name: "add",
  data() {
    return {
      nickname : "XXX",
      age : 12,
      designSheetUrl : '',
      stepNum : 0,
      maxStepNum : 59,
      upMaxStepNum : 59,
      downMaxStepNum : 59,
      play : false,
      playTimer : ''
    };
  },
};
</script>
<style>
/* 页头样式 */
#playHeader{width:98%;height:70px;position:absolute;top:0;display:flex;z-index:1;min-width:500px;left:25px}
#playHeader>div{box-sizing:border-box}
#playHeader #logoimage img{margin:10px 0 0 1px}
#playHeader #headBtnBox{
    /* flex:1;
    min-width:500px;
    margin-bottom:6px;
    display:flex;
    flex-wrap:wrap;
    justify-content:space-around;
    font-size:13px;
    align-items:flex-end */
    user-select: none;
    z-index: 3;
    left: 52%;
    margin-left: -95px;
    font-size: 13px;
    position: absolute;
    margin-bottom:6px;
  }
#playHeader #shareDiv{
    z-index: 3;
    position: absolute;
    margin-top: 13px;
    right: 20%;
}

#playHeader #viewBox{user-select:none;text-align:center;height:58px;overflow:hidden}
#playHeader #viewBox .viewBtn{display:inline-block;width:50px;text-align:center;margin-top:10px;overflow:hidden;cursor:pointer;color:#b2b2b2}
#playHeader #viewBox .viewBtn label{cursor:pointer}
#playHeader #viewBox .viewBtn>div{background-image:url(../static/image/menuZY.png);height:28px;background-repeat:no-repeat;background-position-x:9px;background-size:250%}
#playHeader #viewBox .viewBtn.slt,#playHeader #viewBox .viewBtn:hover{color:#18429a}
#playHeader #viewBox .viewBtn.slt>div,#playHeader #viewBox .viewBtn:hover>div{background-position-x:-79px!important}
#playHeader #viewBox .ctrlShowHideGrid.viewBtn.slt>div,#playHeader #viewBox .ctrlShowHideGrid.viewBtn:hover>div{background-position-x:-79px!important}
#playHeader #btns{user-select:none;display:flex;align-items:flex-end;justify-content:flex-end}
#playHeader #btns div{height:23px;margin:17px 5px;white-space:nowrap}
.greenBtnHollow {
    border: 1px solid #18429a;
    background: #fff;
    color: #18429a;
}
.greenBtnHollow, .greenBtnSolid, .greenBtnSolid:hover, .orangeBtnHollow, .orangeBtnSolid {
    border-radius: 4px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    padding: 8px 16px;
}

#playBody {
    height: calc(100% - 160px);
    width: 98%;
    margin-top: 70px;
    position: absolute;
    overflow: hidden;
}
#patientInfo {
    white-space: nowrap;
    left: 25px;
    top: -10px;
    user-select: none;
    position: absolute;
    width: 250px;
}
#pationName {
    color: #000;
    font-size: 19px;
    line-height: 0px;
    white-space: pre-line;
}

/*方法体中的点击按钮 */
#playBody #pationBox{
    user-select: none;
    left: 8%;
    margin-left: 0px;
    font-size: 13px;
    position: absolute;
    top: -10px;
}
#playBody #pationBox #designSheetDiv{
    position: absolute;
    /* margin-left: 130px; */
    top: 12px;
    width: 400px;
    margin-top: 3px;
}

#playBody #angleBox {
    user-select: none;
    z-index: 3;
    left: 52%;
    margin-left: -230px;
    font-size: 13px;
    position: absolute;
    top: 23px;
}

#playBody #angleBox .cameraDir {
    width: 126px;
    position: relative;
    height: 180px;
    left: 400px
}

#playBody #angleBox .cameraDir ,#playBody #angleBox .cameraDir li {
    position: absolute
}

#playBody #angleBox .cameraDir label,#playBody #angleBox .cameraDir li label {
    display: none
}

#playBody #angleBox .cameraDir .Vupper {
    top: 60px;
    left: 0
}

#playBody #angleBox .cameraDir .Vbottom {
    left: 37px;
    top: 0
}

#playBody #angleBox .cameraDir .Vleft {
    top: 30px;
    left: 76px
}

#playBody #angleBox .cameraDir .Vfront {
    top: 30px;
    left: 38px
}

#playBody #angleBox .cameraDir .Vback {
    top: 60px;
    left: 38px
}

#playBody #angleBox .cameraDir .Vright {
    top: 30px;
    left: 0
}

#playBody #angleBox .cameraDir .Vtop {
    top: 90px;
    left: 38px
}

#playBody #angleBox .cameraDir .Vlower {
    top: 60px;
    left: 76px
}

#playBody #angleBox .cameraDir .setAngleView {
    left: 0;
    top: 90px
}

#playBody #angleBox ul {
    text-align: center;
    float: left
}

#playBody #angleBox li {
    margin-top: 10px;
    display: inline-block;
    cursor: pointer;
    width: 53px;
    text-align: center;
    box-sizing: border-box;
    overflow: hidden;
    padding-bottom: 4px
}

#playBody #angleBox li div {
    height: 28px;
    width: 25px;
    background-image: url(../static/image/viewZY.png?1705402792021);
    background-repeat: no-repeat;
    background-position-y: -28px;
    background-size: 380px 50px;
    margin: 0 auto
}

#playBody #angleBox li label {
    display: block;
    color: #b2b2b2;
    font-weight: 400;
    cursor: pointer
}

#playBody #angleBox li.angleTrue label,#playBody #angleBox li:hover label {
    color: #18429a
}

#playBody #angleBox li.angleTrue div,#playBody #angleBox li:hover div {
    background-position-y: 6px
}

#playBody #angleBox .Vupper div {
    background-position-x: -314px
}

#playBody #angleBox .Vbottom div {
    background-position-x: -42px
}

#playBody #angleBox .Vleft div {
    background-position-x: -225px
}

#playBody #angleBox .Vfront div {
    background-position-x: -133px
}

#playBody #angleBox .Vback div {
    background-position-x: -178px
}

#playBody #angleBox .Vright div {
    background-position-x: -88px
}

#playBody #angleBox .Vtop div {
    background-position-x: -268px
}

#playBody #angleBox .Vlower div {
    background-position-x: 2px
}

#playBody #angleBox .setAngleView div {
    background-position-x: -360px
}

#bgBoxLeft {
    background-image: radial-gradient(rgba(255,255,255,0),#fff 66%)
}
#boxLeft {
    width: 100%;
    position: relative;
    overflow: hidden
}
.backImg0 {
    background: url(../static/image/bg2.png?1704782342472)
}

/* 页脚样式 */
#playFooter{width:98%;height:90px;position:absolute;bottom:0;overflow:hidden;}
#playFooter #plyStepPositionRight{display:none;width:50%;height:86px;left:50%;position:absolute;bottom:2px;box-sizing:border-box}
#playFooter #plyStepPosition{width:calc(100% - 400px);height:86px;left:80px;position:absolute;bottom:2px;box-sizing:border-box}

#playFooter .plyMenu{width:193px;height:43%;float:left;overflow:hidden;position:relative;top: 33px;left:35px;}
#playFooter .plyMenu #plySwitch>div{position:absolute;top:0px;padding:10px;border-radius:50%}

#playFooter .progressMenu{width:400px;height:40%;overflow:hidden;position:relative;top:32px;left:35px;}
#playFooter .progressMenu #plySwitch>div{position:absolute;border-radius:50%}

#playFooter .plyMenu .playBtn{background-repeat:no-repeat;background-position:center;background-size:cover}
#playFooter .plyMenu #plyFirst,#playFooter .plyMenu #plyFirstRight{cursor:pointer;width:13px;height:16px;background-image:url(../static/image/ic_previous_step@3x.png)}
#playFooter .plyMenu #plyFirstBox,#playFooter .plyMenu #plyFirstBoxRight{left:5px}
#playFooter .plyMenu #plyPlay,#playFooter .plyMenu #plyPlayRight{cursor:pointer;width:20px;height:18px;background-image:url(../static/image/stopZY.png)}
#playFooter .plyMenu #plyPlayBox,#playFooter .plyMenu #plyPlayBoxRight{left:55px;top:38px}
#playFooter .plyMenu #plyLast,#playFooter .plyMenu #plyLastRight{cursor:pointer;width:13px;height:16px;background-image:url(../static/image/ic_next_step@3x.png)}
#playFooter .plyMenu #plyLastBox,#playFooter .plyMenu #plyLastBoxRight{left:110px}

#playFooter .plyMenu #plyPlay.slt,#playFooter .plyMenu #plyPlayRight.slt{background-image:url(../static/image/startZY.png)} 
#playFooter #plyPreview,#playFooter #plyPreviewRight{width:950px;height:100%;float:left;position:relative}
#playFooter #plyPreview #dragStep,#playFooter #plyPreview #dragStepRight,#playFooter #plyPreviewRight #dragStep,#playFooter #plyPreviewRight #dragStepRight{position:absolute;z-index:100;background:url(../static/image/ic_next_step@3x.png) no-repeat center;background-size:cover;top:-5px;width:30px;height:36px;line-height:30px;text-align:center;border-radius:50%;left:43px;user-select:none;color:#fff;font-weight:700;font-size:16px;cursor:pointer}
#playFooter #bottomBanner{float:right;position:absolute;right:40px;top:10px}
/* 步数提示框 */
#stepNumber{
  margin-top: -3px;
  right: 2%;
}
/* 当屏幕变小时，动态修改样式 */
@media screen and (max-width:620px){
  #playFooter .progressMenu{top:-40px;left:10px;}
  #playFooter #bottomBanner{display:none; }
  #playHeader #shareDiv{right: 35%;}
  .greenBtnHollow {
    font-size: 12px;
    line-height: 14px;
    padding: 5px 7px;
  }
  #playBody #angleBox {
    left: 54%;
  }
  #loadDiv { margin-left: -125px;}
} 
/* 加载的进度条css样式 */
#loadDiv {
    position: absolute;    
    top: 34%;
    left: 47%;
    margin-left: -115px;
    margin-top: -65px;
    border-radius: 8px;
    overflow: hidden;
    height: 78px;
    width: 237px;
    background-image: url(../static/image/loading.gif);
    padding-top: 82px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue